import React, { FC } from "react";
import { WithAdminAuth } from "../../lib/auth/withAdminAuth";
import { User2Icon } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Typography from "../typography/Typography";
import { Button } from "../ui/button";
import { Link } from "gatsby";
import { useSelector } from "react-redux";
import { RootState } from "@/state/store";

interface UserDropdownType {
  userName: string;
}

const UserDropdown: FC<UserDropdownType> = ({ userName }) => {
  const userStore = useSelector((state: RootState) => state.user);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Button variant={"outline"}>
          <User2Icon /> {userName}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white mt-2 p-4">
        <DropdownMenuItem>
          <Link to="/admin/board-meetings">
            <Typography type="label" tag="span">
              Board meetings
            </Typography>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link to="/admin/edi-messages">
            <Typography type="label" tag="span">
              EDI Messages
            </Typography>
          </Link>
        </DropdownMenuItem>
        {userStore.user?.role === "admin" &&
          <DropdownMenuItem>
            <Link to="/admin/users/overview">
              <Typography type="label" tag="span">
                Members and users
              </Typography>
            </Link>
          </DropdownMenuItem>
          }
        <DropdownMenuSeparator />

        <DropdownMenuItem>
          <Link to="/admin/auth/logout">
            <Typography type="label" tag="span">
              Logout
            </Typography>
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdown;
